import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from '@mui/icons-material/YouTube';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import XIcon from '@mui/icons-material/X';

const PageInfoBar = ({ hours, categories, redes }) => {
  const getSocialLink = (id, username) => {
    if (!username) return null;
    if (username.startsWith('http')) return username;
    
    // Remove @ if user included it
    const cleanUsername = username.startsWith('@') ? username.slice(1) : username;

    const baseUrls = {
      instagram: 'https://instagram.com/',
      facebook: 'https://facebook.com/',
      tiktok: 'https://tiktok.com/@',
      youtube: 'https://youtube.com/@',
      x: 'https://x.com/',
      linkedin: 'https://linkedin.com/in/'
    };

    return baseUrls[id] ? `${baseUrls[id]}${cleanUsername}` : `https://${username}`;
  };

  const socialIcons = [
    { id: 'instagram', icon: <InstagramIcon fontSize="small" />, link: getSocialLink('instagram', redes?.instagram) },
    { id: 'facebook', icon: <FacebookIcon fontSize="small" />, link: getSocialLink('facebook', redes?.facebook) },
    { id: 'tiktok', icon: <img src="https://cdn-icons-png.flaticon.com/512/3046/3046121.png" alt="tiktok" style={{ width: 18, height: 18 }} />, link: getSocialLink('tiktok', redes?.tiktok) },
    { id: 'youtube', icon: <YouTubeIcon fontSize="small" />, link: getSocialLink('youtube', redes?.youtube) },
    { id: 'x', icon: <XIcon fontSize="small" />, link: getSocialLink('x', redes?.x) },
    { id: 'linkedin', icon: <LinkedInIcon fontSize="small" />, link: getSocialLink('linkedin', redes?.linkedin) }
  ];

  const themeColor = '#0E2465';
  const inactiveColor = '#CBD5E1';

  return (
    <Box
      sx={{
        width: '95%',
        maxWidth: '1200px',
        mx: 'auto',
        mt: 2,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: { xs: 2, md: 4 },
        py: 2,
        px: 1,
        color: '#64748B'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <AccessTimeIcon sx={{ color: themeColor, fontSize: 20 }} />
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {hours || "Lunes a Viernes de 8:00 - 17:00 hrs"}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <LocalOfferIcon sx={{ color: themeColor, fontSize: 20 }} />
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {categories || "Servicios"}
        </Typography>
      </Box>

      <Box sx={{ flex: 1, display: { xs: 'none', md: 'block' } }} />

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        {socialIcons.map((social) => {
          const isActive = !!social.link;
          return (
            <Box 
              key={social.id}
              component={isActive ? "a" : "div"}
              href={isActive ? social.link : undefined}
              target={isActive ? "_blank" : undefined}
              rel={isActive ? "noopener noreferrer" : undefined}
              sx={{ 
                color: isActive ? themeColor : inactiveColor, 
                transition: 'all 0.2s',
                '&:hover': isActive ? { opacity: 0.7, transform: 'translateY(-2px)' } : {},
                display: 'flex',
                cursor: isActive ? 'pointer' : 'default',
                pointerEvents: isActive ? 'auto' : 'none',
                filter: social.id === 'tiktok' 
                  ? (isActive 
                      ? 'invert(11%) sepia(87%) saturate(1914%) hue-rotate(212deg) brightness(89%) contrast(92%)' 
                      : 'grayscale(1) opacity(0.3)')
                  : 'none'
              }}
            >
              {social.icon}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default PageInfoBar;
